import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeResponse } from './normalize';

export const fetchOCTableViewColumns = createProvider(api.fetchOCTableViewColumns)
  .andThen((res) => normalizeResponse(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch OC table view columns aborted');
    } else {
      console.error('Fetch OC table view columns was failed:', error);
    }
    throw error;
  });

export const saveOCTableViewColumns = createProvider(api.saveOCTableViewColumns).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Save OC table view columns aborted');
  } else {
    console.error('Save OC table view columns was failed:', error);
  }
  throw error;
});
